<template>
  <div class="main" ref="mainScroll">
    <div class="content">
      <!-- 顶部 -->
      <div class="topWai">
        <img
          style="cursor: pointer"
          src="@/assets/main1.png"
          @click="$router.push('/console/shop')"
        />
        <!-- <div class="immediately">
          <a-button
            class="newButtonDark"
            @click="$router.push('/console/shop')"
          >
            立即开启
            <ArrowRightOutlined style="position: relative; top: 1px" />
          </a-button>
          <div style="font-size: 16px; color: #333333; margin-top: 20px">
            第三代GPU云平台全新上市了！
          </div>
        </div> -->
        <div class="seed">
          <div
            class="seedItem"
            @click="
              !token && !user
                ? changeLoginPopState(true)
                : ((modalVisible = true), (modalType = 1))
            "
          >
            <img src="@/assets/main13.png" />
            <div class="text">
              <div class="textTop">
                {{ !token && !user ? "登录注册福利" : "领取专属福利" }}
              </div>
              <div class="textBottom">立即畅享高端显卡，体验超强算力</div>
            </div>
          </div>
          <div
            class="seedItem"
            @click="
              modalVisible = true;
              modalType = 2;
            "
          >
            <img src="@/assets/main14.png" />
            <div class="text">
              <div class="textTop">AI交流基地</div>
              <div class="textBottom">更多大神共同交流体验</div>
            </div>
          </div>
          <div class="seedItem" @click="window.open(this.http_Docs)">
            <img src="@/assets/main15.png" />
            <div class="text">
              <div class="textTop">新手指引</div>
              <div class="textBottom">创建实例，一键启用</div>
            </div>
          </div>
          <div
            class="seedItem"
            @click="
              modalVisible = true;
              modalType = 3;
            "
          >
            <img src="@/assets/main16.png" />
            <div class="text">
              <div class="textTop">售后保障</div>
              <div class="textBottom">专业、贴心、及时响应</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 中间 -->
      <div class="middle">
        <!-- AI产品介绍 -->
        <div class="product">
          <div class="titel"><span class="aiItem">AI</span>产品介绍</div>
          <div
            class="productWai"
            @mouseenter="recommendMouse = true"
            @mouseleave="recommendMouse = false"
          >
            <div class="catalogue">
              <div
                class="cataloguDiv"
                :class="{
                  divActive1: recomNumber == 1,
                }"
                @mouseenter="recomNumber = 1"
                @click="recomNumber = 1"
              >
                算力市场
              </div>
              <div
                class="cataloguDiv"
                :class="{
                  divActive2: recomNumber == 2,
                }"
                @mouseenter="recomNumber = 2"
                @click="recomNumber = 2"
              >
                应用商店
              </div>
              <div
                class="cataloguDiv"
                :class="{
                  divActive3: recomNumber == 3,
                }"
                @mouseenter="recomNumber = 3"
                @click="recomNumber = 3"
              >
                晨羽<span class="aiItem">AI</span>学院
              </div>
              <div
                class="cataloguDiv"
                :class="{
                  divActive4: recomNumber == 4,
                }"
                @mouseenter="recomNumber = 4"
                @click="recomNumber = 4"
              >
                大模型API服务
              </div>
              <div
                class="cataloguDiv"
                :class="{
                  divActive5: recomNumber == 5,
                }"
                @mouseenter="recomNumber = 5"
                @click="recomNumber = 5"
              >
                私有化部署
              </div>
            </div>
            <div class="recommend">
              <img
                class="recommendImg"
                :src="
                  recomNumber == 1
                    ? main3
                    : recomNumber == 2
                    ? main10
                    : recomNumber == 3
                    ? main9
                    : recomNumber == 4
                    ? main11
                    : recomNumber == 5
                    ? main12
                    : ''
                "
              />
              <div class="recommendText">
                {{
                  recomNumber == 1
                    ? "晨羽智云依托强大的硬件和软件服务团队，推出第三代GPU云平台，全力保障用户的数据安全。"
                    : recomNumber == 2
                    ? "提供最前沿的AI POD镜像，欢迎加入应用商店大家庭。"
                    : recomNumber == 3
                    ? "提供最好的学习AI体验，最新的AI课程，最强的老师，并提供实习机会。"
                    : recomNumber == 4
                    ? "高效接入，自由扩展，轻松参与算力租赁红利。"
                    : recomNumber == 5
                    ? "晨羽智云提供1对1的企业服务，为每个客户量身定制AI算力解决方案。我们的专业团队将全程支持， 助力企业实现智能化转型升级。"
                    : ""
                }}
              </div>
              <a-button
                class="newButtonDark"
                @click="
                  recomNumber == 1
                    ? $router.push('/console/market')
                    : recomNumber == 2
                    ? $router.push('/console/shop')
                    : recomNumber == 3
                    ? $router.push('/console/institute')
                    : recomNumber == 4
                    ? $router.push('/console/apiServer')
                    : recomNumber == 5
                    ? $router.push('/console/connectUs')
                    : ''
                "
              >
                {{ recomNumber == 5 ? "联系我们" : "立即使用" }}
                <ArrowRightOutlined style="position: relative; top: 1px" />
              </a-button>
            </div>
          </div>
        </div>
        <!-- 应用场景 -->
        <div class="scene">
          <div class="titel">应用场景</div>
          <div class="sceneWai">
            <div
              class="sceneItem"
              :class="{ sceneActive: sceneActiveNumber == 1 }"
              @mouseenter="sceneActiveNumber = 1"
            >
              <div class="introduce">
                <div class="introduceTetle">高校院所</div>
                <div class="introduceText">
                  面向高校自建AI计算集群的场景，提供了从硬件采购到定
                  制化系统设计的全链路解决方案。帮助本地AI计算资源轻
                  松上云，为科研团队提供稳定易用的算力管理平台。
                </div>
              </div>
              <div
                class="introduceImg"
                :style="`background-image: url(${main5});background-size: cover;background-repeat: no-repeat;background-position: center;`"
              ></div>
            </div>
            <div
              class="sceneItem"
              :class="{ sceneActive: sceneActiveNumber == 2 }"
              @mouseenter="sceneActiveNumber = 2"
            >
              <div class="introduce">
                <div class="introduceTetle">科研机构</div>
                <div class="introduceText">
                  晨羽智云平台可以为科研机构提供专业的AI计算服务，支
                  持从基础研究到应用开发的各个阶段。我们平台能够在短
                  时间内助力科研团队快速完成AI开发任务。可提供稳定、
                  高效的计算支持，加速科研项目的进展和成果的转化。
                </div>
              </div>
              <div
                class="introduceImg"
                :style="`background-image: url(${main6});background-size: cover;background-repeat: no-repeat;background-position: center;`"
              ></div>
            </div>
            <div
              class="sceneItem"
              :class="{ sceneActive: sceneActiveNumber == 3 }"
              @mouseenter="sceneActiveNumber = 3"
            >
              <div class="introduce">
                <div class="introduceTetle">AI企业</div>
                <div class="introduceText">
                  晨羽智云可以企业智能化、数字化提供定制化的AI计算方
                  案，帮助他们在竞争激烈的市场脱颖而出。无论是大数据
                  模型分析、机器学习模型的部署，还是AI驱动的产品研发，
                  我们都可以提供所需的AI算力资源和业务定制能力。
                </div>
              </div>
              <div
                class="introduceImg"
                :style="`background-image: url(${main7});background-size: cover;background-repeat: no-repeat;background-position: center;`"
              ></div>
            </div>
            <div
              class="sceneItem"
              :class="{ sceneActive: sceneActiveNumber == 4 }"
              @mouseenter="sceneActiveNumber = 4"
            >
              <div class="introduce">
                <div class="introduceTetle">初学入门</div>
                <div class="introduceText">
                  我们免费具备最直观的一站学习AI课程，即使是小白也可
                  轻松快速上手模拟训练。平台拥有前沿丰富的AI全栈资源，
                  赋能应用更简单、更高效！
                </div>
              </div>
              <div
                class="introduceImg"
                :style="`background-image: url(${main8});background-size: cover;background-repeat: no-repeat;background-position: center;`"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="buttom">
        <div class="buttomWai">
          <img class="logo" src="@/assets/logo3.png" alt="" />
          <div class="message">
            <div class="messageItem">
              <div class="messageTetle">关于我们:</div>
              <div class="messageValue">
                <div>公司名称:&nbsp;</div>
                <div>晨羽智云（杭州）科技有限公司</div>
              </div>
              <div class="messageValue">
                <div>公司地址:&nbsp;</div>
                <div>浙江省杭州市西湖区教工路88号11楼</div>
              </div>
            </div>
            <div class="messageItem">
              <div class="messageTetle">联系我们:</div>
              <div class="messageValue">
                <div>邮箱:&nbsp;</div>
                <div>qu@cyuai.com</div>
              </div>
              <div class="messageValue">
                <div>电话:&nbsp;</div>
                <div>132-0571-2110</div>
              </div>
            </div>
            <div class="messageItemQR">
              <div class="codeQR">
                <img
                  class="codeRimg"
                  :src="`https://img.cyuai.com/cpn/material/2d94989e80984f97a76126639603cbad.png?${dayjs().format(
                    'YYYYMMDDHH'
                  )}`"
                  alt="img"
                />
                <div class="codeRdiv">联系客服</div>
              </div>
              <div class="codeQR">
                <img
                  class="codeRimg"
                  :src="`https://img.cyuai.com/cpn/material/83ab67cf9a7940e3bea37b28d8fa07ed.png?${dayjs().format(
                    'YYYYMMDDHH'
                  )}`"
                  alt="img"
                />
                <div class="codeRdiv">交流群</div>
              </div>
              <div class="codeQR">
                <img
                  class="codeRimg"
                  :src="`https://img.cyuai.com/cpn/material/75fa88df078f43489e70002cec77b564.png?${dayjs().format(
                    'YYYYMMDDHH'
                  )}`"
                  alt="img"
                />
                <div class="codeRdiv">创作者服务</div>
              </div>
            </div>
          </div>
          <div class="social">
            <div class="location">
              <div class="locationFont">公司地址:&nbsp;</div>
              <span
                class="locationText"
                @click="$router.push('/console/connectUs')"
              >
                查看地图位置
              </span>
              <svg
                @click="$router.push('/console/connectUs')"
                t="1734346083830"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="19260"
                width="16"
                height="16"
              >
                <path
                  d="M832 960H192c-70.692 0-128-57.308-128-128l32-192c8.889-53.336 42.768-106.663 94.725-122.957 10.451 20.487 22.264 40.161 35.049 58.957H224c-35.346 0-52.333 20.667-64 64l-32 192c0 35.346 28.654 64 64 64h640c35.346 0 64-28.654 64-64l-32-192c-8.333-37-28.654-64-64-64h-1.346c12.67-18.764 24.382-38.418 34.745-58.911C885.204 533.437 918.841 586.714 928 640l32 192c0 70.692-57.308 128-128 128zM511.99 768.01s-304-169.21-304-422.4C208 196 344.095 64.011 511.987 64.011 679.883 64.011 816 196 815.99 345.61c-1.185 256.282-304 422.4-304 422.4z m0-640.001C392 128.018 272.009 221.616 272 356.84 272 554.474 512 704 512 704s240-149.526 240-347.16C751.411 221.618 632 128 511.99 128.009zM512 480c-70.693 0-128-57.308-128-128 0-70.693 57.307-128 128-128 70.692 0 128 57.308 128 128 0 70.692-57.308 128-128 128z m0-192c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
                  p-id="19261"
                  fill="#2c2c2c"
                ></path>
              </svg>
            </div>
            <div class="link">
              <svg
                t="1737367401044"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2480"
                width="36"
                height="36"
                @click="
                  mixinOpenNewWindow(
                    'https://www.douyin.com/user/MS4wLjABAAAAXiBIiGJVgmahCEv-8k_cqeW_0netiiSxGPxsPXyJ2GEPF_QMWwTmMtQmdCSYosBZ'
                  )
                "
              >
                <path
                  d="M0 0m184.32 0l655.36 0q184.32 0 184.32 184.32l0 655.36q0 184.32-184.32 184.32l-655.36 0q-184.32 0-184.32-184.32l0-655.36q0-184.32 184.32-184.32Z"
                  fill="#111111"
                  p-id="2481"
                ></path>
                <path
                  d="M204.27776 670.59712a246.25152 246.25152 0 0 1 245.97504-245.97504v147.57888a98.49856 98.49856 0 0 0-98.38592 98.38592c0 48.34304 26.14272 100.352 83.54816 100.352 3.81952 0 93.55264-0.88064 93.55264-77.19936V134.35904h157.26592a133.31456 133.31456 0 0 0 133.12 132.99712l-0.13312 147.31264a273.152 273.152 0 0 1-142.62272-38.912l-0.06144 317.98272c0 146.00192-124.24192 224.77824-241.14176 224.77824-131.74784 0.03072-231.1168-106.56768-231.1168-247.92064z"
                  fill="#FF4040"
                  p-id="2482"
                ></path>
                <path
                  d="M164.92544 631.23456a246.25152 246.25152 0 0 1 245.97504-245.97504v147.57888a98.49856 98.49856 0 0 0-98.38592 98.38592c0 48.34304 26.14272 100.352 83.54816 100.352 3.81952 0 93.55264-0.88064 93.55264-77.19936V94.99648h157.26592a133.31456 133.31456 0 0 0 133.12 132.99712l-0.13312 147.31264a273.152 273.152 0 0 1-142.62272-38.912l-0.06144 317.98272c0 146.00192-124.24192 224.77824-241.14176 224.77824-131.74784 0.03072-231.1168-106.56768-231.1168-247.92064z"
                  fill="#00F5FF"
                  p-id="2483"
                ></path>
                <path
                  d="M410.91072 427.58144c-158.8224 20.15232-284.44672 222.72-154.112 405.00224 120.40192 98.47808 373.68832 41.20576 380.70272-171.85792l-0.17408-324.1472a280.7296 280.7296 0 0 0 142.88896 38.62528V261.2224a144.98816 144.98816 0 0 1-72.8064-54.82496 135.23968 135.23968 0 0 1-54.70208-72.45824h-123.66848l-0.08192 561.41824c-0.11264 78.46912-130.9696 106.41408-164.18816 30.2592-83.18976-39.77216-64.37888-190.9248 46.31552-192.57344z"
                  fill="#FFFFFF"
                  p-id="2484"
                ></path>
              </svg>
              <!-- <svg
                t="1734345399015"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3824"
                width="40"
                height="40"
              >
                <path
                  d="M664.250054 368.541681c10.015098 0 19.892049 0.732687 29.67281 1.795902-26.647917-122.810047-159.358451-214.077703-310.826188-214.077703-169.353083 0-308.085774 114.232694-308.085774 259.274068 0 83.708494 46.165436 152.460344 123.281791 205.78483l-30.80868 91.730191 107.688651-53.455469c38.558178 7.53665 69.459978 15.308661 107.924012 15.308661 9.66308 0 19.230993-0.470721 28.752858-1.225921-6.025227-20.36584-9.521864-41.723264-9.521864-63.862493C402.328693 476.632491 517.908058 368.541681 664.250054 368.541681zM498.62897 285.87389c23.200398 0 38.557154 15.120372 38.557154 38.061874 0 22.846334-15.356756 38.156018-38.557154 38.156018-23.107277 0-46.260603-15.309684-46.260603-38.156018C452.368366 300.994262 475.522716 285.87389 498.62897 285.87389zM283.016307 362.090758c-23.107277 0-46.402843-15.309684-46.402843-38.156018 0-22.941502 23.295566-38.061874 46.402843-38.061874 23.081695 0 38.46301 15.120372 38.46301 38.061874C321.479317 346.782098 306.098002 362.090758 283.016307 362.090758zM945.448458 606.151333c0-121.888048-123.258255-221.236753-261.683954-221.236753-146.57838 0-262.015505 99.348706-262.015505 221.236753 0 122.06508 115.437126 221.200938 262.015505 221.200938 30.66644 0 61.617359-7.609305 92.423993-15.262612l84.513836 45.786813-23.178909-76.17082C899.379213 735.776599 945.448458 674.90216 945.448458 606.151333zM598.803483 567.994292c-15.332197 0-30.807656-15.096836-30.807656-30.501688 0-15.190981 15.47546-30.477129 30.807656-30.477129 23.295566 0 38.558178 15.286148 38.558178 30.477129C637.361661 552.897456 622.099049 567.994292 598.803483 567.994292zM768.25071 567.994292c-15.213493 0-30.594809-15.096836-30.594809-30.501688 0-15.190981 15.381315-30.477129 30.594809-30.477129 23.107277 0 38.558178 15.286148 38.558178 30.477129C806.808888 552.897456 791.357987 567.994292 768.25071 567.994292z"
                  fill="#616466"
                  p-id="3825"
                ></path>
              </svg> -->
              <svg
                t="1737367539107"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5526"
                width="36"
                height="36"
                @click="
                  mixinOpenNewWindow(
                    'https://space.bilibili.com/3546669016680687?spm_id_from=333.337.search-card.all.click'
                  )
                "
              >
                <path
                  d="M0 0m184.32 0l655.36 0q184.32 0 184.32 184.32l0 655.36q0 184.32-184.32 184.32l-655.36 0q-184.32 0-184.32-184.32l0-655.36q0-184.32 184.32-184.32Z"
                  fill="#EC5D85"
                  p-id="5527"
                ></path>
                <path
                  d="M512 241.96096h52.224l65.06496-96.31744c49.63328-50.31936 89.64096 0.43008 63.85664 45.71136l-34.31424 51.5072c257.64864 5.02784 257.64864 43.008 257.64864 325.03808 0 325.94944 0 336.46592-404.48 336.46592S107.52 893.8496 107.52 567.90016c0-277.69856 0-318.80192 253.14304-324.95616l-39.43424-58.368c-31.26272-54.90688 37.33504-90.40896 64.68608-42.37312l60.416 99.80928c18.18624-0.0512 41.18528-0.0512 65.66912-0.0512z"
                  fill="#EF85A7"
                  p-id="5528"
                ></path>
                <path
                  d="M512 338.5856c332.8 0 332.8 0 332.8 240.64s0 248.39168-332.8 248.39168-332.8-7.75168-332.8-248.39168 0-240.64 332.8-240.64z"
                  fill="#EC5D85"
                  p-id="5529"
                ></path>
                <path
                  d="M281.6 558.08a30.72 30.72 0 0 1-27.47392-16.97792 30.72 30.72 0 0 1 13.73184-41.216l122.88-61.44a30.72 30.72 0 0 1 41.216 13.74208 30.72 30.72 0 0 1-13.74208 41.216l-122.88 61.44a30.59712 30.59712 0 0 1-13.73184 3.23584zM752.64 558.08a30.60736 30.60736 0 0 1-12.8512-2.83648l-133.12-61.44a30.72 30.72 0 0 1-15.04256-40.7552 30.72 30.72 0 0 1 40.76544-15.02208l133.12 61.44A30.72 30.72 0 0 1 752.64 558.08zM454.656 666.88a15.36 15.36 0 0 1-12.288-6.1952 15.36 15.36 0 0 1 3.072-21.49376l68.5056-50.91328 50.35008 52.62336a15.36 15.36 0 0 1-22.20032 21.23776l-31.5904-33.024-46.71488 34.72384a15.28832 15.28832 0 0 1-9.13408 3.04128z"
                  fill="#EF85A7"
                  p-id="5530"
                ></path>
                <path
                  d="M65.536 369.31584c15.03232 101.90848 32.84992 147.17952 44.544 355.328 14.63296 2.18112 177.70496 10.04544 204.05248-74.62912a16.14848 16.14848 0 0 0 1.64864-10.87488c-30.60736-80.3328-169.216-60.416-169.216-60.416s-10.36288-146.50368-11.49952-238.83776zM362.25024 383.03744l34.816 303.17568h34.64192L405.23776 381.1328zM309.52448 536.28928h45.48608l16.09728 158.6176-31.82592 1.85344zM446.86336 542.98624h45.80352V705.3312h-33.87392zM296.6016 457.97376h21.39136l5.2736 58.99264-18.91328 2.26304zM326.99392 457.97376h21.39136l2.53952 55.808-17.408 1.61792zM470.62016 459.88864h19.456v62.27968h-19.456zM440.23808 459.88864h22.20032v62.27968h-16.62976z"
                  fill="#FFFFFF"
                  p-id="5531"
                ></path>
                <path
                  d="M243.56864 645.51936a275.456 275.456 0 0 1-28.4672 23.74656 242.688 242.688 0 0 1-29.53216 17.52064 2.70336 2.70336 0 0 1-4.4032-1.95584 258.60096 258.60096 0 0 1-5.12-29.57312c-1.41312-12.1856-1.95584-25.68192-2.16064-36.36224 0-0.3072 0-2.5088 3.01056-1.90464a245.92384 245.92384 0 0 1 34.22208 9.5744 257.024 257.024 0 0 1 32.3584 15.17568c0.52224 0.256 2.51904 1.4848 0.09216 3.77856z"
                  fill="#EB5480"
                  p-id="5532"
                ></path>
                <path
                  d="M513.29024 369.31584c15.03232 101.90848 32.84992 147.17952 44.544 355.328 14.63296 2.18112 177.70496 10.04544 204.05248-74.62912a16.14848 16.14848 0 0 0 1.64864-10.87488c-30.60736-80.3328-169.216-60.416-169.216-60.416s-10.36288-146.50368-11.49952-238.83776zM810.00448 383.03744l34.816 303.17568h34.64192L852.992 381.1328zM757.27872 536.28928h45.48608l16.09728 158.6176-31.82592 1.85344zM894.6176 542.98624h45.80352V705.3312H906.5472zM744.35584 457.97376h21.39136l5.2736 58.99264-18.91328 2.26304zM774.74816 457.97376h21.39136l2.53952 55.808-17.408 1.61792zM918.3744 459.88864h19.456v62.27968h-19.456zM887.99232 459.88864h22.20032v62.27968h-16.62976z"
                  fill="#FFFFFF"
                  p-id="5533"
                ></path>
                <path
                  d="M691.32288 645.51936a275.456 275.456 0 0 1-28.4672 23.74656 242.688 242.688 0 0 1-29.53216 17.52064 2.70336 2.70336 0 0 1-4.4032-1.95584 258.60096 258.60096 0 0 1-5.12-29.57312c-1.41312-12.1856-1.95584-25.68192-2.16064-36.36224 0-0.3072 0-2.5088 3.01056-1.90464a245.92384 245.92384 0 0 1 34.22208 9.5744 257.024 257.024 0 0 1 32.3584 15.17568c0.52224 0.256 2.51904 1.4848 0.09216 3.77856z"
                  fill="#EB5480"
                  p-id="5534"
                ></path>
              </svg>
              <svg
                t="1737367632021"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6960"
                width="36"
                height="36"
                @click="
                  mixinOpenNewWindow(
                    'https://www.xiaohongshu.com/user/profile/652f3c9e0000000002010e4d'
                  )
                "
              >
                <path
                  d="M1021.72444445 836.54883555V187.48757333C1021.72444445 85.61550222 938.38449778 2.27555555 836.51242667 2.27555555H187.48757333C85.61550222 2.27555555 2.27555555 85.61550222 2.27555555 187.48757333v649.06126222c0 100.85262222 81.70154667 183.57361778 182.2264889 185.1756089h654.9959111c100.48853333-1.60199111 182.22648889-84.28657778 182.2264889-185.1756089"
                  fill="#FF2442"
                  p-id="6961"
                ></path>
                <path
                  d="M726.52117333 366.36444445h57.344v20.53461333c0 1.6384 0.80099555 2.40298667 2.36657778 2.36657777 34.00590222-1.01944889 68.26666667 0.07281778 85.81575111 34.95253334 10.44935111 20.68024889 8.30122667 52.13752889 7.71868445 76.82275556-0.03640889 1.45635555 0.65536 2.25735111 2.03889778 2.40298666 4.00497778 0.36408889 7.90072889 0.72817778 11.68725333 1.20149334 67.61130667 8.11918222 54.24924445 71.87114667 54.46769777 121.96977777 0.10922667 17.47626667-1.85685333 30.25578667-5.82542222 38.41137778-8.37404445 16.89372445-23.37450667 26.57848889-45.00138666 28.98147555H854.97173333l-21.55406222-50.02581333a1.6384 1.6384 0 0 1 0.10922667-1.52917333 1.56558222 1.56558222 0 0 1 1.31072-0.72817778l45.72956444-0.03640889c2.54862222 0 4.95160889-1.09226667 6.69923556-2.98552889a10.12167111 10.12167111 0 0 0 2.69425777-7.02691555c-0.21845333-15.29173333-0.32768-30.54705778-0.25486222-45.80238223 0-13.72615111-6.48078222-20.75306667-19.55157333-21.11715555-14.78200889-0.36408889-42.78044445-0.36408889-84.03171555 0.07281778-1.45635555 0-2.18453333 0.80099555-2.18453334 2.36657777l-0.21845333 126.81216H726.44835555l-0.18204444-127.35829333a2.25735111 2.25735111 0 0 0-2.22094222-2.33016889h-53.52106667a2.54862222 2.54862222 0 0 1-2.47580444-2.54862222l0.07281777-55.41432889c0-1.85685333 0.87381333-2.80348445 2.62144-2.80348444l52.90211556 0.10922667a2.51221333 2.51221333 0 0 0 1.82044444-0.80099556 2.76707555 2.76707555 0 0 0 0.72817778-1.89326222v-47.91409778a3.16757333 3.16757333 0 0 0-3.05834666-3.24039111l-32.65877334 0.14563555c-1.71121778 0-2.54862222-0.91022222-2.54862222-2.69425778l-0.10922666-55.7056c0-1.6384 0.72817778-2.43939555 2.36657777-2.43939555h33.82385778c1.45635555 0 2.18453333-0.72817778 2.18453333-2.29376l0.36408889-20.46179555z m59.38289778 137.37073777l35.57148444-0.07281777c0.58254222 0 1.12867555-0.25486222 1.52917334-0.6917689a2.29376 2.29376 0 0 0 0.61895111-1.6019911l-0.18204445-44.52807112c0-3.49525333-2.54862222-6.33514667-5.64337777-6.33514666l-28.54456889 0.07281778a5.35210667 5.35210667 0 0 0-4.00497778 1.89326222 6.80846222 6.80846222 0 0 0-1.6384 4.55111111l0.18204444 44.52807111c0 1.23790222 0.98304 2.18453333 2.11171556 2.18453333zM417.95584 507.74016c-13.83537778 0.25486222-38.84828445 4.11420445-44.30961778-13.68974222-3.31320889-10.63139555 4.18702222-25.44981333 8.73813333-35.82634667 12.96156445-29.52760889 25.66826667-59.16444445 38.15651556-88.91050666 0.50972445-1.20149333 1.38353778-1.82044445 2.62144-1.82044445h54.72256c0.47331555 0 0.87381333 0.25486222 1.09226667 0.65536a1.45635555 1.45635555 0 0 1 0.14563555 1.31072l-31.67573333 74.01927111c-0.72817778 1.71121778-0.54613333 3.64088889 0.40049778 5.24288a5.17006222 5.17006222 0 0 0 4.36906667 2.47580444h46.89464888c0.58254222 0 1.09226667 0.29127111 1.41994667 0.76458667 0.29127111 0.50972445 0.36408889 1.09226667 0.10922667 1.6384-13.54410667 31.56650667-27.05180445 62.91456-40.52309334 94.04416-1.34712889 3.09475555-1.92967111 5.38851555-1.71121778 6.84487111 0.47331555 3.16757333 2.25735111 4.76956445 5.31569778 4.80597334l29.67324445 0.18204444c1.71121778 0.03640889 2.25735111 0.87381333 1.56558222 2.54862222l-19.18748445 45.14702222a3.78652445 3.78652445 0 0 1-3.64088888 2.51221334c-30.14656 0.36408889-51.22730667 0.36408889-63.24224-0.18204444-19.87925333-0.91022222-24.75804445-18.31367111-17.03936-36.26325334l27.27025778-63.64273778a1.38353778 1.38353778 0 0 0-0.10922667-1.23790222 1.23790222 1.23790222 0 0 0-1.09226667-0.61895111zM190.58232889 694.00803555h-21.48124444l-21.04433778-49.40686222a1.60199111 1.60199111 0 0 1 0.10922666-1.49276444 1.45635555 1.45635555 0 0 1 1.23790222-0.72817778l29.70965334-0.07281778a6.95409778 6.95409778 0 0 0 6.80846222-7.09973333l0.80099556-262.03477333a2.54862222 2.54862222 0 0 1 2.51221333-2.62144h51.11808c2.40298667 0 3.60448 1.27431111 3.64088889 3.78652444 0.21845333 88.72846222 0.21845333 175.92775111 0 261.63427556-0.14563555 35.17098667-16.45681778 59.20085333-53.41184 58.03576888z"
                  fill="#FFFFFF"
                  p-id="6962"
                ></path>
                <path
                  d="M670.08739555 694.00803555h-193.91374222l25.99594667-58.6183111a3.45884445 3.45884445 0 0 1 3.38602667-2.22094223l47.47719111 0.07281778c1.67480889 0 2.54862222-0.83740445 2.54862222-2.54862222v-177.85742223c0-1.52917333-0.72817778-2.29376-2.18453333-2.29376l-31.49368889-0.03640888c-1.41994667 0-2.54862222-1.23790222-2.54862223-2.73066667v-57.05272889c0-0.87381333 0.65536-1.60199111 1.49276445-1.60199111h128.37774222c1.60199111 0 2.36657778 0.83740445 2.36657778 2.51221333l0.07281778 56.43377778c0 1.6384-0.80099555 2.47580445-2.40298667 2.47580444h-31.74855111c-1.45635555 0-2.18453333 0.76458667-2.18453333 2.29376v177.74819556c0 1.71121778 0.83740445 2.54862222 2.43939555 2.54862222l50.31708445 0.10922667c1.38353778 0 2.07530667 0.72817778 2.07530666 2.18453333L670.08739555 694.04444445zM901.02897778 394.65415111c39.61287111-27.23384889 67.50208 42.19790222 24.10268444 54.10360889-7.06332445 1.96608-18.31367111 2.07530667-33.71463111 0.36408889-1.38353778-0.14563555-2.03889778-0.91022222-2.03889778-2.36657778-0.21845333-16.384-3.45884445-41.72458667 11.65084445-52.06471111zM354.20387555 598.79879111l-26.2144 61.05770667c-2.36657778 5.46133333-4.95160889 5.57056-7.8279111 0.43690667-19.29671111-34.87971555-25.85031111-63.35146667-29.63683556-106.71445334-2.91271111-33.67822222-5.42492445-67.35644445-7.60945778-101.10748444-0.07281778-1.52917333 0.61895111-2.29376 2.07530667-2.29376l53.12056889 0.03640888c1.49276445 0 2.33016889 0.80099555 2.43939555 2.3301689 2.73066667 39.24878222 5.60696889 78.38833778 8.59249778 117.41866666 0.76458667 10.04885333 2.47580445 18.38648889 5.09724445 25.01290667a4.73315555 4.73315555 0 0 1-0.0364089 3.82293333zM75.09333333 596.54144v-2.51221333a25.70467555 25.70467555 0 0 0 4.73315556-11.50520889c3.93216-43.32657778 7.13614222-86.61674667 9.64835556-129.94332445 0.10922667-1.34712889 0.76458667-2.03889778 2.03889777-2.03889778h54.24924445c0.47331555 0 0.94663111 0.21845333 1.31072 0.61895112 0.32768 0.36408889 0.50972445 0.87381333 0.47331555 1.38353778a7226.07217778 7226.07217778 0 0 1-9.57553777 119.67601777c-2.54862222 28.94506667-11.79648 67.68412445-31.1296 91.16785778-1.23790222 1.49276445-2.29376 1.34712889-3.09475556-0.47331555L75.09333333 596.54144zM445.08046222 694.00803555h-78.57038222l-10.01244445-3.96856888c-1.41994667-0.54613333-1.82044445-1.52917333-1.16508444-2.94912l24.64881778-56.43377778c0.72817778-1.6384 1.89326222-2.25735111 3.56807111-1.82044444 26.94257778 7.31818667 58.14499555 4.29624889 85.70652445 4.40547555 1.71121778 0.03640889 2.18453333 0.87381333 1.45635555 2.47580445l-25.63185778 58.25422222z"
                  fill="#FFFFFF"
                  p-id="6963"
                ></path>
              </svg>
            </div>
          </div>

          <div class="icp">
            <div style="margin-right: 20px">
              <span @click="mixinOpenNewWindow(`${http_Docs}/agreement`)">
                服务协议
              </span>
              <span @click="mixinOpenNewWindow(`${http_Docs}/privacy`)">
                隐私政策
              </span>
              <span @click="mixinOpenNewWindow(http_Docs)">关于我们</span>
            </div>
            <span @click="mixinOpenNewWindow('https://beian.miit.gov.cn/')">
              浙ICP备2022035832号
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="bgAdvertisementVisible"
      class="backgroundAdvertisement"
      :style="`background-image: url(https://img.cyuai.com/cpn/material/d7c0143bac1e4ae69612ac7626b29b18.png?${dayjs().format(
        'YYYYMMDDHH'
      )});background-size: cover;background-repeat: no-repeat;background-position: center;`"
    >
      <CloseOutlined @click="closeBgAdvertisement()" />
    </div>
    <div @click="clickScrollTop" class="clickScrollTop" v-if="clickTopShow">
      <DoubleLeftOutlined class="iconTop" />
      <span>返回顶部</span>
    </div>
    <!-- 侧边广告福利 -->
    <div class="welfareSide">
      <img
        class="buttonSide"
        @click="
          modalVisible = true;
          modalType = 1;
        "
        src="@/assets/advertisingSide.png"
      />
    </div>
    <a-modal
      class="newFooter mainmodal"
      centered
      v-model:open="modalVisible"
      :footer="null"
      :closable="false"
    >
      <img
        v-if="modalType == 1"
        style="width: 100%"
        :src="`https://img.cyuai.com/cpn/material/d1c4f51824d64e0ba2438f0c2034c30e.png?${dayjs().format(
          'YYYYMMDDHH'
        )}`"
        alt="img"
      />
      <img
        v-if="modalType == 2"
        style="width: 100%"
        :src="`https://img.cyuai.com/cpn/material/031fdfdeee364d92bd844215165f24f7.png?${dayjs().format(
          'YYYYMMDDHH'
        )}`"
        alt="img"
      />
      <img
        v-if="modalType == 3"
        style="width: 100%"
        :src="`https://img.cyuai.com/cpn/material/3c956d2ecfb3453f911aa62a9f48e091.png?${dayjs().format(
          'YYYYMMDDHH'
        )}`"
        alt="img"
      />
    </a-modal>
  </div>
</template>

<script>
import {
  DoubleLeftOutlined,
  ArrowRightOutlined,
  CloseOutlined,
} from "@ant-design/icons-vue";
export default {
  components: {
    DoubleLeftOutlined,
    ArrowRightOutlined,
    CloseOutlined,
  },
  name: "mainPage",
  data() {
    return {
      window,
      timeFor: null,
      recommendMouse: false,
      recomNumber: 1,
      sceneActiveNumber: 1,
      // 备案地址
      main5: require("@/assets/main5.png"),
      main6: require("@/assets/main6.png"),
      main7: require("@/assets/main7.png"),
      main8: require("@/assets/main8.png"),
      main3: require("@/assets/main3.png"),
      main9: require("@/assets/main9.png"),
      main10: require("@/assets/main10.png"),
      main11: require("@/assets/main11.png"),
      main12: require("@/assets/main12.png"),
      modalVisible: false,
      modalType: 1,
      bgAdvertisementVisible: false,
    };
  },
  watch: {},
  props: {},
  created() {
    if (localStorage["bgAdLocalTime"] != this.dayjs().format("YYYYMMDD")) {
      this.bgAdvertisementVisible = true;
    }
  },
  mounted() {
    // 时间循环
    if (this.timeFor) {
      clearInterval(this.timeFor);
      this.timeFor = null;
    }
    this.timeFor = setInterval(() => {
      console.log("timeFor" + this.recomNumber);
      if (!this.recommendMouse && !this.isTouch()) {
        this.recomNumber = (this.recomNumber % 5) + 1;
      }
    }, 3000);

    console.log("mainPage_mounted");
    document.addEventListener("scroll", this.scrolFun);
    this.$refs.mainScroll?.addEventListener("scroll", this.mainScrollFun);
  },
  beforeUnmount() {
    clearInterval(this.timeFor);
    this.timeFor = null;

    console.log("beforeUnmount");
    document.removeEventListener("scroll", this.scrolFun);
    this.$refs.mainScroll?.removeEventListener("scroll", this.mainScrollFun);
  },
  methods: {
    clickScrollTop() {
      this.$refs.mainScroll.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    // 滚动函数
    scrolFun() {
      if (document.documentElement.scrollTop >= 300 && !this.clickTopShow) {
        this.changeClickTopShowState(true);
      } else if (
        document.documentElement.scrollTop < 300 &&
        this.clickTopShow
      ) {
        this.changeClickTopShowState(false);
      }
    },
    // 滚动函数
    mainScrollFun() {
      if (this.$refs.mainScroll?.scrollTop >= 300 && !this.clickTopShow) {
        this.changeClickTopShowState(true);
      } else if (this.$refs.mainScroll?.scrollTop < 300 && this.clickTopShow) {
        this.changeClickTopShowState(false);
      }
    },
    closeBgAdvertisement() {
      localStorage["bgAdLocalTime"] = this.dayjs().format("YYYYMMDD");
      this.bgAdvertisementVisible = false;
    },
  },
};
</script>

<style lang="scss">
.mainmodal {
  .ant-modal-content {
    background: none !important;
    box-shadow: none !important;
    user-select: none;
  }
}
</style>
<style lang="scss" scoped>
@media (max-width: 1400px) {
  .main {
    // 第一个
    .topWai {
      .seed {
        padding: 0 20px !important;
        position: relative !important;
        bottom: 0 !important;
        margin-top: 10px;
      }
    }
    // 中间部分
    .middle {
      padding: 50px 20px 0 !important;
    }
  }
}
@media (max-width: 1200px) {
  .main {
    .middle {
      .product {
        .productWai {
          flex-direction: column;
          align-items: center;
          .catalogue {
            height: fit-content !important;
            flex-direction: row !important;
            flex-wrap: wrap;
            .cataloguDiv {
              margin: 0 5px 10px;
            }
          }
          .recommend {
            width: 100% !important;
            height: fit-content !important;
            .recommendImg {
              width: 100% !important;
            }
          }
        }
      }
      .scene {
        margin-left: 0 !important;
        margin-right: 0 !important;
        .sceneItem {
          margin: 0 5px 10px !important;
        }
        .sceneActive {
          .introduce {
            width: 267px !important;
            background: linear-gradient(
              1deg,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.63) 100%
            ) !important;
            box-shadow: 0px 0px 36px 7px rgba(31, 94, 158, 0.06) !important;
            .introduceTetle {
              font-size: 24px !important;
              color: #000000 !important;
            }
            .introduceText {
              color: #858585 !important;
            }
          }
          .introduceImg {
            width: 267px !important;
          }
        }
      }
    }
  }
}
@media (max-width: 600px) {
  .main {
    .topWai {
      // padding-bottom: 90px;
      .seed {
        .seedItem {
          width: 100% !important;
        }
      }
    }
    .middle {
      .product {
        .productWai {
          .catalogue {
            .cataloguDiv {
              margin: 0 0 10px !important;
              width: 100% !important;
            }
          }
          .recommend {
            padding: 0 !important;
            .recommendText {
              width: calc(100% - 40px) !important;
              margin: 10px 20px !important;
            }
            .newButtonDark {
              margin: 0 20px 20px;
            }
          }
        }
      }
      .scene {
        .sceneItem {
          margin: 0 0 10px !important;
          .introduce {
            width: 100% !important;
          }
          .introduceImg {
            width: 100% !important;
            display: flex;
            align-items: center;
          }
        }
      }
    }
    .buttom {
      .social {
        .locationFont {
          display: none;
        }
        .link {
          margin: 0 !important;
        }
      }
    }
  }
  .clickScrollTop {
    bottom: 52px !important;
    right: 22px !important;
  }
}
// 侧边广告福利
@media (max-width: 600px) {
  .welfareSide {
    display: none;
  }
}
.main {
  font-family: PingFangSC, PingFang SC;

  height: 100%;
  overflow-y: overlay;
  scroll-behavior: smooth; // 平滑滚动
  position: relative;
  // 主要内容
  .content {
    // pointer-events: none;
    // 第一个
    .topWai {
      width: 100%;
      background: #eef4f6;
      box-sizing: border-box;
      position: relative;
      img {
        width: 100%;
      }
      .immediately {
        position: absolute;
        bottom: 20px;
        left: calc(50% - 113px);
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      // 小广告
      .seed {
        width: 100%;
        padding: 0 100px;
        box-sizing: border-box;
        position: absolute;
        bottom: -80px;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        .seedItem {
          margin: 10px 0;
          width: 300px;
          min-height: 120px;
          background: #ffffff;
          box-shadow: 0px 0px 20px 0px rgba(0, 96, 255, 0.08);
          border-radius: 16px;
          display: flex;
          align-items: center;
          padding: 10px 20px;
          box-sizing: border-box;
          cursor: pointer;

          // 2025.2.28 ↓↓↓
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 1%,
            rgba(211, 196, 255, 0.15) 99%
          );
          box-shadow: 0px 0px 23px 0px rgba(44, 16, 90, 0.09);
          border-radius: 16px;
          border: 2px solid rgba(255, 255, 255, 0.83);
          backdrop-filter: blur(8px);
          // 2025.2.28 ↑↑↑
          &:hover {
            background-image: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/618activity-2023/1685521453105827117.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
          img {
            width: 80px;
            height: 80px;
          }
          .text {
            .textTop {
              font-size: 18px;
              color: #000000;
            }
            .textBottom {
              margin-top: 10px;
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }
    }
    // 中间部分
    .middle {
      background-image: url("@/assets/main4.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding: 150px 20px 0;
      box-sizing: border-box;
      .product,
      .scene {
        .titel {
          font-weight: 600;
          font-size: 45px;
          color: #000000;
          line-height: 76px;
          letter-spacing: 2px;
          margin-bottom: 50px;
        }
      }
      // 产品介绍
      .product {
        display: flex;
        flex-direction: column;
        align-items: center;

        .aiItem {
          font-family: MF-LiHei, MF-LiHei;
          font-weight: 400;
        }
        .productWai {
          width: 1200px;
          max-width: 100%;
          display: flex;
          justify-content: space-between;
          // 左边的切换
          .catalogue {
            height: 650px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            .cataloguDiv {
              display: flex;
              align-items: center;
              justify-content: center;

              width: 218px;
              padding: 23px 0;
              background: rgba(255, 255, 255, 0.46);
              box-shadow: 0px 0px 8px 0px rgba(72, 72, 72, 0.12);
              border-radius: 13px;

              font-weight: 500;
              color: #000000;
              font-size: 19px;
              line-height: 26px;
              cursor: pointer;
            }
            .divActive1 {
              color: #ffffff;
              background: linear-gradient(270deg, #20ceff 0%, #8bdef6 100%);
              box-shadow: 0px 0px 8px 0px rgba(198, 198, 198, 0.06);
            }
            .divActive2 {
              color: #ffffff;
              background: linear-gradient(0deg, #28bf92 0%, #06d4a6 100%);
              box-shadow: 0px 0px 10px 0px rgba(72, 72, 72, 0.12);
            }
            .divActive3 {
              color: #ffffff;
              background: linear-gradient(95deg, #fe977f 0%, #f56351 100%);
              box-shadow: 0px 0px 10px 0px rgba(72, 72, 72, 0.12);
            }
            .divActive4 {
              color: #ffffff;
              background: linear-gradient(90deg, #5080ff 0%, #0f50df 100%);
              box-shadow: 0px 0px 10px 0px rgba(72, 72, 72, 0.12);
            }
            .divActive5 {
              color: #ffffff;
              background: linear-gradient(88deg, #bf9cfe 0%, #9a5eff 100%);
              box-shadow: 0px 0px 10px 0px rgba(72, 72, 72, 0.12);
            }
          }
          // 右边的内容
          .recommend {
            width: calc(880px + 60px);
            height: 650px;
            padding: 30px;
            box-sizing: border-box;
            background: rgba(247, 249, 255, 0.42);
            box-shadow: 0px 0px 36px 7px rgba(31, 94, 158, 0.06);
            border-radius: 32px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .recommendImg {
              width: 880px;
            }
            .recommendText {
              margin: 10px 0;
              width: 100%;
              min-height: 66px;
              font-weight: 400;
              font-size: 18px;
              color: #666666;
              line-height: 33px;
            }
            .newButtonDark {
              width: fit-content;
              border-radius: 27px;
              height: 50px;
              font-size: 21px;
            }
          }
        }
      }
      // 应用场景
      .scene {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 100px -20px 0;
        padding: 0 0 100px;
        box-sizing: border-box;
        .sceneWai {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          .sceneItem {
            border-radius: 28px;
            overflow: hidden;
            margin-bottom: 10px;
            cursor: pointer;
            .introduce {
              transition: all 0.2s;
              width: 267px;
              height: 222px;
              background: linear-gradient(
                1deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.63) 100%
              );
              box-shadow: 0px 0px 36px 7px rgba(31, 94, 158, 0.06);

              padding: 20px;
              box-sizing: border-box;
              .introduceTetle {
                font-weight: 500;
                font-size: 24px;
                color: #000000;
                line-height: 64px;
              }
              .introduceText {
                font-weight: 400;
                font-size: 13px;
                color: #858585;
                line-height: 26px;

                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
              }
            }
            .introduceImg {
              overflow: hidden;
              transition: all 0.2s;
              width: 267px;
              height: 274px;
              display: flex;
              justify-content: center;
            }
          }
          .sceneActive {
            .introduce {
              width: 386px;
              background: linear-gradient(131deg, #8a9bff 0%, #6177fa 100%);
              box-shadow: 0px 0px 36px 7px rgba(118, 212, 255, 0.15);
              .introduceTetle {
                font-size: 28px;
                color: #ffffff;
              }
              .introduceText {
                color: #ffffff;
              }
            }
            .introduceImg {
              width: 386px;
            }
          }
        }
      }
    }
    .buttom {
      background: #f2f9ff;
      display: flex;
      justify-content: center;
      padding: 50px 20px;
      box-sizing: border-box;
      .buttomWai {
        width: 100%;
        max-width: 1200px;
        display: flex;
        flex-direction: column;
        .logo {
          width: 190px;
        }
        .message {
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .messageItem {
            margin: 30px 0 20px;
            .messageTetle {
              margin-bottom: 20px;
              font-weight: 600;
              font-size: 20px;
              color: #000000;
              line-height: 28px;
            }
            .messageValue {
              margin: 10px 0;
              width: fit-content;
              max-width: 346px;

              font-weight: 400;
              font-size: 18px;
              color: #313233;
              line-height: 25px;

              display: flex;

              div:nth-child(1) {
                white-space: nowrap;
              }
            }
          }
          .messageItemQR {
            margin: 30px 0 20px;
            display: flex;
            flex-wrap: wrap;
            .codeQR {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 10px;
              .codeRimg {
                width: 120px;
                height: 120px;
              }
              .codeRdiv {
                margin-top: 10px;
                font-weight: 400;
                font-size: 15px;
                color: rgba(0, 0, 0, 0.77);
                line-height: 21px;
              }
            }
            .codeQR:nth-child(1) {
              margin-right: 50px;
            }
            .codeQR:nth-child(2) {
              margin-right: 50px;
            }
          }
        }
        .social {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          .location {
            display: flex;
            align-items: center;
            width: 346px;
            max-width: 100%;

            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            margin: 10px 0;
            .locationText {
              cursor: pointer;
              &:hover {
                color: #666;
              }
            }
            .locationFont {
              font-size: 18px;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              user-select: none;
              opacity: 0;
            }
            .icon {
              margin-left: 5px;
            }
          }
          .link {
            margin: 0 80px;
            flex-wrap: wrap;
            .icon {
              margin: 10px 0;
              margin-right: 50px;
              cursor: pointer;
            }
          }
        }
        .icp {
          color: #666;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin: 10px 0;
          span {
            cursor: pointer;
            &:hover {
              &:hover {
                opacity: 0.8;
              }
            }
          }
        }
      }
    }
  }
  .clickScrollTop {
    width: 69px;
    height: 69px;

    background: #ffffff;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    position: fixed;
    bottom: 52px;
    right: 32px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding: 5px 0;
    box-sizing: border-box;
    cursor: pointer;
    .iconTop {
      font-size: 20px;
      transform: rotate(90deg);
    }
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 11px;
      color: #666666;
      line-height: 16px;
      font-style: normal;
    }
  }
  // 侧边广告福利
  .welfareSide {
    width: 69px;
    height: 69px;
    position: fixed;
    bottom: 331px;
    right: 32px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    .buttonSide {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
  // 背景广告
  .backgroundAdvertisement {
    position: fixed;
    top: 52px;
    left: 0;
    width: 100%;
    height: calc(100% - 52px);
    background: #000000c1;
    .anticon-close {
      font-size: 25px;
      position: absolute;
      top: 20px;
      right: 20px;
      color: white;
      cursor: pointer;
    }
  }
}
</style>